import React from 'react';
import DatePicker from 'components/molecule/DateRangePicker/DatePicker';
import { Controller } from 'react-hook-form';

export function MobileDateFilter({ control, name, startEndOfDay = 'start', onSubmit, onReset }) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <DatePicker
          field={field}
          startEndOfDay={startEndOfDay}
          startIcon
          onSubmit={onSubmit}
          onCancel={() => onReset(name)}
          showTime
        />
      )}
    />
  );
}
